'use strict';

var _ = require('lodash');
var PooledSeasonalityChartsHelper = function PooledSeasonalityChartsHelper(seasonalityReviewConstants, seasonalityConstants, svgPatternService, momentService) {
  function getDepartureDatesPerDoW(calendarData, selectedDow, outliers) {
    var startDate = calendarData.startDepartureDate;
    var endDate = calendarData.endDepartureDate;
    var result = [];
    var departureDate = startDate.setDay(selectedDow);
    if (departureDate.isBefore(startDate)) {
      departureDate = departureDate.add(7, 'days');
    }
    result.push(checkDepartureDateEvent(calendarData, departureDate, outliers));
    var rangeScanComplete = false;
    while (!rangeScanComplete) {
      departureDate = departureDate.add(7, 'days');
      if (departureDate.isBefore(endDate) || departureDate.isSame(endDate)) {
        result.push(checkDepartureDateEvent(calendarData, departureDate, outliers));
      } else {
        rangeScanComplete = true;
      }
    }
    return result;
  }
  function checkDepartureDateEvent(calendarData, departureDate, outliers) {
    var dateObj;
    if (_.isArray(calendarData.specialEvents) && calendarData.specialEvents.length > 0) {
      _.forEach(calendarData.specialEvents, function (event) {
        if (departureDate.isBetween(event.startDate, event.endDate, 'days', '[]') || departureDate.isSame(event.startDate, 'days') || departureDate.isSame(event.endDate, 'days')) {
          dateObj = {
            date: departureDate,
            eventType: event.eventType,
            eventName: event.eventName
          };
          return false;
        }
      });
    }
    if (_.isUndefined(dateObj) && outliers.length > 0) {
      var outlier = _.find(outliers, {
        departureDate: departureDate.format(momentService.FORMAT.DATE_TIME_ISO_WITHOUT_SECONDS)
      });
      if (!_.isUndefined(outlier)) {
        dateObj = {
          date: departureDate,
          eventType: seasonalityReviewConstants.EVENT_TYPE.OUTLIER,
          eventName: 'normal',
          isRegularOutlier: outlier.isRegularOutlier,
          isMappedOutlier: outlier.isMappedOutlier
        };
      }
    }
    if (_.isUndefined(dateObj)) {
      dateObj = {
        date: departureDate,
        eventType: 'normal',
        eventName: 'normal'
      };
    }
    return dateObj;
  }
  function getScenarioName(calendarData) {
    var scenarioName;
    var calendarStatus = calendarData.calendarEntryStatus;
    if (calendarStatus === seasonalityConstants.CALENDAR_STATUSES.NOT_PUBLISHED) {
      scenarioName = computeScenarioName(calendarData.calendarName, calendarData.market);
    } else if (calendarStatus === seasonalityConstants.CALENDAR_STATUSES.PUBLISHED) {
      scenarioName = seasonalityReviewConstants.PROFILE_STATUS_PUBLISHED;
    }
    return scenarioName;
  }
  function isProfileInactiveOrPublishing(calendarData) {
    var calendarStatus = calendarData.calendarEntryStatus;
    return calendarStatus === seasonalityConstants.CALENDAR_STATUSES.RUNNING || calendarStatus === seasonalityConstants.CALENDAR_STATUSES.INACTIVE;
  }
  function computeScenarioName(calendarName, market) {
    return _.join([seasonalityReviewConstants.SYSTEM_USER, calendarName, market], '-');
  }
  function getProfileName(flowType, profileType) {
    if (profileType === seasonalityReviewConstants.PROFILE_TYPE.INDEX) {
      return flowType === seasonalityReviewConstants.FLOW_TYPE.REGULAR ? seasonalityReviewConstants.HEP.REGULAR_INDEX_PROFILE : seasonalityReviewConstants.HEP.MAPPED_INDEX_PROFILE;
    } else if (profileType === seasonalityReviewConstants.PROFILE_TYPE.DEMAND) {
      return flowType === seasonalityReviewConstants.FLOW_TYPE.REGULAR ? seasonalityReviewConstants.HEP.REGULAR_DEMAND_PROFILE : seasonalityReviewConstants.HEP.MAPPED_DEMAND_PROFILE;
    }
  }
  function getSimpleLegend() {
    return [{
      label: 'Original data',
      fill: seasonalityReviewConstants.COLOR_THEME.FILL_DARK
    }, {
      label: 'Smoothed data',
      fill: seasonalityReviewConstants.COLOR_THEME.FILL_LIGHT
    }];
  }
  function getStaticLegend() {
    return [{
      label: 'Exclusion/Outlier',
      fill: svgPatternService.getPatternUrl('user-exclusion')
    }];
  }
  function getDefaultLegend() {
    return {
      label: 'No Data',
      fill: svgPatternService.getPatternUrl('gap-pattern')
    };
  }
  return {
    getDepartureDatesPerDoW: getDepartureDatesPerDoW,
    getScenarioName: getScenarioName,
    getProfileName: getProfileName,
    getSimpleLegend: getSimpleLegend,
    getStaticLegend: getStaticLegend,
    getDefaultLegend: getDefaultLegend,
    isProfileInactiveOrPublishing: isProfileInactiveOrPublishing
  };
};
PooledSeasonalityChartsHelper.$inject = ['PooledSeasonalityReviewConstants', 'SeasonalityConstants', 'SvgPatternService', 'MomentService'];
module.exports = PooledSeasonalityChartsHelper;